import {
  FinalizedReactionaryBlueprint,
  reactionaryTemplateMethod,
} from "../../typescript-44ms-reactionary-template-method";

export const startTheRevolution = (
  blueprint: FinalizedReactionaryBlueprint
) => {
  const aReactionaryReadyToGo = reactionaryTemplateMethod(blueprint);
  return aReactionaryReadyToGo;
};
